/* tslint:disable */
/* eslint-disable */
export enum EnumRequestApplications {
	Interagencias = 'Interagencias',
	NMVIAJES = 'NMViajes'
}
